import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { icons } from '../../../assets/icons';
import './index.scss';
import { LoaderComponent } from '../../../helpers/components/loader';
import { useDispatch, useSelector } from 'react-redux';
import { getBillsByAdmin } from '../../../api/redux/slices/Admin';
import Pagination from '../../../helpers/components/Pagination';
import useStableArr from '../../../utils/useStableArr';
import { handleCheck, handleCheckAll } from '../../../utils/checkUtilsAdmin';
import { convertDate } from '../../../helpers/modules';
import { CSVLink } from 'react-csv';

const BillPage = () => {
    const { bills, checkedList, total } = useSelector((state) => state.admin);
    const dispatch = useDispatch();
    const params = useParams();

    const [page, setPage] = useState(Number(params.page) || 1);
    const [newArr, setNewArr] = useState([]);
    const [isCheck, setIsCheck] = useState(false);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('accesstoken');

    const stableDispatch = useCallback(() => {
        setLoading(true);
        dispatch(
            getBillsByAdmin({
                token: token,
                search: search,
                page: search ? 1 : page,
            }),
        )
            .unwrap()
            .catch((err) => {
                console.error('Error fetching bills:', err);
            })
            .finally(() => setLoading(false));
    }, [dispatch, page, search, token]);

    useEffect(() => {
        if (token) {
            stableDispatch();
        }
    }, [stableDispatch, search, token]);

    useStableArr(bills, checkedList, setNewArr, setIsCheck);

    const headers = [
        { label: 'NUMÉRO', key: 'reference' },
        { label: 'DATE', key: 'createdAt' },
        { label: 'CLIENT', key: 'client_name' },
        { label: 'SOCIÉTÉ', key: 'company_name' },
        { label: 'TOTAL', key: 'total' },
    ];

    const csvBillReport = {
        filename: 'Factures.csv',
        data: checkedList.map((bill) => ({
            reference: bill.reference,
            createdAt: convertDate(bill.createdAt, 'DD-MM-YYYY'),
            client_name: bill.client_name,
            company_name: bill.company_name,
            total: bill.total || 0,
        })),
        headers: headers,
    };

    return (
        <div id="billPageAdmin">
            <div className="navbar">
                <div className="left">
                    <div className="nav-search">
                        <input
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            type="search"
                            placeholder="Rechercher ..."
                        />
                        <icons.FiSearch className="searchicon" />
                    </div>
                </div>
                <div className="right">
                    <div className="right-items">
                        <Link to="/admin/createFacture" className="button-primary">
                            <icons.BsPlus />
                            Créer une facture
                        </Link>
                        <CSVLink {...csvBillReport} target="blank">
                            <button className="button-nature" title="exporter facture(s)">
                                <icons.BiExport />
                            </button>
                        </CSVLink>
                    </div>
                </div>
            </div>
            <div id="head">
                <div className="title-user">
                    <h1>Factures Proformat</h1>
                </div>
            </div>
            <div id="billsContent">
                <table id="bills">
                    <thead>
                        <tr id="titres">
                            <td className="input-check">
                                <input
                                    onChange={() => handleCheckAll(dispatch, newArr, setNewArr, isCheck, setIsCheck)}
                                    checked={isCheck}
                                    type="checkbox"
                                    className="checkbox"
                                />
                            </td>
                            <td>NUMÉRO</td>
                            <td>DATE</td>
                            <td>CLIENT</td>
                            <td>SOCIÉTÉ</td>
                            <td>TOTAL</td>
                            <td>ACTION</td>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7">
                                    <LoaderComponent margin="10%" />
                                </td>
                            </tr>
                        ) : newArr?.length > 0 ? (
                            newArr.map((bill, index) => (
                                <tr className="delivery" key={index}>
                                    <td className="input-check">
                                        <input
                                            onChange={() => handleCheck(dispatch, newArr, setNewArr, bill?._id)}
                                            checked={bill?.checked ?? false}
                                            type="checkbox"
                                            className="checkbox"
                                        />
                                    </td>
                                    <td>{bill.reference}</td>
                                    <td>{convertDate(bill?.createdAt, 'DD-MM-YYYY')}</td>
                                    <td>{bill?.client_name || '-'}</td>
                                    <td>{bill?.company_name || '-'}</td>
                                    <td>{bill?.total != null ? Number(bill?.total).toFixed(2) : 0} DT</td>
                                    <td className="last-delivery-element">
                                        <Link
                                            to={`/admin/bills/bill_details/${page}/${bill._id}`}
                                            className="link-delivery"
                                        >
                                            <icons.BsEye className="see-delivery" />
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '50px' }}>
                                    Aucune facture trouvée
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination page={page} setPage={setPage} pageLink="/admin/bills/" total={total} />
        </div>
    );
};

export default BillPage;